export const WhatsAppContactConsultor =
  "https://api.whatsapp.com/send?phone=551197075-9107&text=Quero%20falar%20com%20um%20consultor%20Strm";

export const WhatsAppContactDistro =
  "https://api.whatsapp.com/send?phone=551197075-9107&text=Quero%20distribuir%20meus%20próximos%20lançamentos%20com%20vocês";
